// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SummaryLoyaltyPoints-module-loyaltyPrice-AR29G{font-size:16px !important;color:#373a36 !important;font-weight:var(--weight-light);width:-webkit-fit-content;width:fit-content;text-align:center}.SummaryLoyaltyPoints-module-loyaltyUrl-0M8I6{width:-webkit-fit-content;width:fit-content}.SummaryLoyaltyPoints-module-loyaltyPriceWrapper-c2vY-{display:flex;align-items:center;justify-content:center;width:100%;gap:5px;margin-top:22px !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loyaltyPrice": "SummaryLoyaltyPoints-module-loyaltyPrice-AR29G",
	"loyaltyUrl": "SummaryLoyaltyPoints-module-loyaltyUrl-0M8I6",
	"loyaltyPriceWrapper": "SummaryLoyaltyPoints-module-loyaltyPriceWrapper-c2vY-"
};
export default ___CSS_LOADER_EXPORT___;
